import { render, staticRenderFns } from "./deanInputSelect.vue?vue&type=template&id=5132c306&scoped=true"
import script from "./deanInputSelect.vue?vue&type=script&lang=ts"
export * from "./deanInputSelect.vue?vue&type=script&lang=ts"
import style0 from "./deanInputSelect.vue?vue&type=style&index=0&id=5132c306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5132c306",
  null
  
)

export default component.exports